import { esi } from '../api'
import { EthercatDevice } from '../entities/EthercatDevice'
import { fetchDescriptions, findDevicesByType } from '/@/shared/worker-helpers'
import { Description } from '/@/shared/importers/interfaces'
import Base from './Base'
import NProgress from 'nprogress'
import { empty, isAuthSkipped } from '/@/shared/utils'

class SearchAndProcessDescriptions extends Base {
  private devices: EthercatDevice[] = []

  private constructor(devices: EthercatDevice[]) {
    super()
    this.devices = devices
  }

  private async process() {
    // The portal is the only ESI source, so there is nothing to look up without a real session
    if (!this.app.isLoggedIn || isAuthSkipped()) {
      return
    }

    NProgress.start()

    try {
      return await this.search()
    } finally {
      NProgress.done()
    }
  }

  private async search() {
    const results = await esi.search(this.devices)

    if (!results.length) {
      return []
    }

    if (results.some((description) => description.esis.length > 1)) {
      throw new Error('multiple ESI per description not implemented yet.')
    }

    const descriptions = ((await fetchDescriptions(results)) as Description[]) ?? []

    const devices = descriptions
      .filter((description) => description !== undefined)
      .map((description) => {
        const devices = findDevicesByType(description.type, this.devices)

        if (!devices.length) {
          return
        }

        devices.forEach((device) => this.ethercat.applyDeviceDescription({ device, description }))
        return devices
      })
      .filter((devices) => !empty(devices))
      .flat()

    return devices
  }

  public static run(devices: EthercatDevice[]) {
    const instance = new SearchAndProcessDescriptions(devices)
    return instance.process()
  }
}

export default SearchAndProcessDescriptions
